import React, {useState} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import Select from "../Select";
import SelectIcon from "../Icons/SelectIcon";
import russianSize from "../../../mocks/sizes/russian-size";
import Table from "../Table";
import Modal from "../Modal";
import P from "../Typography/P";
import sizes from "../../../mocks/sizes";
import Button from "../Button";

import styles from "./size.module.scss";

function ManSize(props) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };
  const {content, current, productName, name, compact, onChange} = props;
  const handleChange = (event) => {
    if (event.target.value === `table`) {
      openModal();
    } else {
      onChange(name, event.target.value);
    }
  };
  return (
    <div className={styles.main}>
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <React.Fragment>
          <h2 className={styles.tableTitle}>Таблица размеров</h2>
          <Table items={sizes[productName].man} />
          <div className={styles.norm}>Допустимая норма: ±2 см</div>
        </React.Fragment>
      </Modal>
      <P className={styles.label}>Мужской размер</P>
      {compact ? (
        <div className={styles.content}>
          {content.map(({label, value, disabled}) => (
            <Button
              variant="outlined"
              size="small"
              style="secondary"
              disabled={disabled}
              key={value}
              onClick={() => onChange(name, value)}
              className={classNames(
                styles.buttonCompact,
                current === value && styles.buttonCompactActive
              )}
            >
              {label}
            </Button>
          ))}
          <button className={styles.footerCompact} onClick={() => openModal()}>
            Открыть таблицу размеров
          </button>
        </div>
      ) : (
        <Select
          value={current}
          onChange={handleChange}
          options={content}
          renderValue={(value) => (
            <Grid container>
              <Grid item xs={9}>
                Размер – {content.find((item) => item.value === value).label}
              </Grid>
              {russianSize[productName] &&
                russianSize[productName].man &&
                russianSize[productName].man[value] && (
                  <Grid item xs={3} className={styles.russianSize}>
                    {russianSize[productName].man[value]}
                  </Grid>
                )}
            </Grid>
          )}
          renderOption={(label, value) => {
            const selected = current === value;
            return (
              <Grid
                container
                className={selected ? styles.optionSelected : styles.option}
              >
                <Grid item xs={9}>
                  {label}
                </Grid>
                {russianSize[productName] &&
                  russianSize[productName].man &&
                  russianSize[productName].man[value] && (
                    <Grid item xs={2} className={styles.russianSize}>
                      {russianSize[productName].man[value]}
                    </Grid>
                  )}
                {selected && (
                  <Grid item xs={1} className={styles.check}>
                    <SelectIcon />
                  </Grid>
                )}
              </Grid>
            );
          }}
          renderFooter={() => (
            <button className={styles.tableLink} value="table">
              Открыть таблицу размеров
            </button>
          )}
        />
      )}
    </div>
  );
}

ManSize.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  ),
  current: PropTypes.string,
  compact: PropTypes.bool,
  onChange: PropTypes.func
};

export default ManSize;
